import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { Header } from '../components/layout/Header';
import { Sidebar } from '../components/layout/Sidebar';
import { MarketStatsBar } from '../components/markets/MarketStatsBar';
import { TrendingRow } from '../components/markets/TrendingRow';
import { MarketTable } from '../components/markets/MarketTable';
import { SectorPerformance } from '../components/markets/SectorPerformance';
type FilterTab = 'All' | 'Spot' | 'Futures' | 'New Listings';
export function MarketsPage() {
  const [activeTab, setActiveTab] = useState<FilterTab>('All');
  const [searchQuery, setSearchQuery] = useState('');
  const tabs: FilterTab[] = ['All', 'Spot', 'Futures', 'New Listings'];
  return <div className="flex h-screen bg-background-primary text-text-primary overflow-hidden font-sans" data-id="element-2443">
      <Sidebar data-id="element-2444" />

      <div className="flex-1 flex flex-col min-w-0 mesh-bg" data-id="element-2445">
        <Header data-id="element-2446" />

        <main className="flex-1 overflow-y-auto p-4 md:p-6 space-y-4 md:space-y-6 relative z-0" data-id="element-2447">
          {/* Page Header */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-id="element-2448">
            <div className="flex items-center gap-4" data-id="element-2449">
              <h1 className="text-2xl font-heading text-text-primary" data-id="element-2450">
                Markets
              </h1>
              <div className="flex items-center gap-1 bg-background-secondary p-1 rounded-lg" data-id="element-2451">
                {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`px-3 py-1.5 text-sm font-ui rounded-lg transition-all ${activeTab === tab ? 'bg-background-elevated text-text-primary' : 'text-text-secondary hover:text-text-primary hover:bg-background-elevated/50'}`} data-id="element-2452">
                    {tab}
                  </button>)}
              </div>
            </div>

            <div className="flex items-center gap-3 px-4 py-2.5 bg-background-secondary border border-border-default focus-within:border-brand-purple focus-within:ring-1 focus-within:ring-brand-purple rounded-full transition-all w-full md:w-72" data-id="element-2453">
              <Search size={16} className="text-text-tertiary flex-shrink-0" data-id="element-2454" />
              <input type="text" placeholder="Search markets..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="flex-1 bg-transparent text-sm text-text-primary placeholder:text-text-tertiary focus:outline-none" data-id="element-2455" />
            </div>
          </div>

          {/* Stats Banner */}
          <MarketStatsBar data-id="element-2456" />

          {/* Trending */}
          <TrendingRow data-id="element-2457" />

          {/* Full Market Table */}
          <MarketTable filterTab={activeTab} searchQuery={searchQuery} data-id="element-2458" />

          {/* Sector Performance */}
          <SectorPerformance data-id="element-2459" />
        </main>
      </div>
    </div>;
}